export default (state = {}, action) => {
  let { type, payload } = action
  switch (type) {
  case 'USER_GET':
    return payload
  case 'LOGOUT':
    return {}
  default:
    return state
  }
}
